
var Model = require("../types/Model.js");
// eslint-disable-next-line node/no-missing-require
var ReactNative = require("react-native");
var Dimensions = ReactNative.Dimensions;
var Platform = ReactNative.Platform;
var global = require("global");
var debounce = require("debounce");

module.exports = new Model({
	name: "size",
	init: init,
	uninit: uninit,
	recalculate: recalculate,

	_handleResize: null,
	_subscription: null,
});

function init() {
	this.recalculate();
	this._handleResize = debounce(recalculate.bind(this), 1000);

	if(global.window && global.window.addEventListener)
		global.window.addEventListener("resize", this._handleResize);
	if (Dimensions && typeof Dimensions.addEventListener === "function")
		this._subscription = Dimensions.addEventListener("change", this._handleResize);
}

function uninit() {
	if(global.window && global.window.removeEventListener)
		global.window.removeEventListener("resize", this._handleResize);

	if (this._subscription && typeof this._subscription.remove === "function")
		this._subscription.remove();
}


function recalculate() {
	if(Platform.OS === "web")
		Dimensions.set();
	var newSize = get();
	var currentSize = this.data;
	if(currentSize && currentSize.width === newSize.width && currentSize.height === newSize.height)
		return;
	this.push(newSize);
}

function get() {
	try {
		if ((global.window.device && global.window.device.platform === "iOS") || (Platform && Platform.OS === "ios"))
			return Dimensions.get("window");
		return Dimensions.get("screen");
	} catch(e){
		return Dimensions.get("window");
	}
}
